// @flow
import { useState, useEffect } from "react";

import SourceReferenceCollection from "../models/concepts/SourceReferenceCollection";
import ModularUIRequest from "../modularui/ModularUIRequest";

import { useProgressIndicator } from "../hooks/useProgressIndicator";
import { useLocale } from "../hooks/useI18n";

import type ContentModel from "../models/content/ContentModel";

/**
 * Hook to retrieve multiple source references at once
 */
export const useContentFromSourceReferences = (
  sourceReferences: SourceReferenceCollection,
  renderChildSections: boolean,
): Array<ContentModel> => {
  const [content, setContent] = useState([]);
  const localeCode = useLocale();

  const { start, finish } = useProgressIndicator();

  const hrefs = sourceReferences
    .map((sourceReference) => sourceReference.link.selfhref.href)
    .filter((href, index, self) => self.indexOf(href) === index)
    .map((href) => href.toString());

  const allHrefs = JSON.stringify(hrefs);
  useEffect(() => {
    const requests = JSON.parse(allHrefs).map((href) => {
      const modularuiRequest = new ModularUIRequest(href);
      modularuiRequest.locale = localeCode;
      return modularuiRequest.fetchContent(renderChildSections);
    });

    start();
    Promise.all(requests).then((responseContent) => {
      setContent(responseContent);
      finish();
    });

    // start and finish don't change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allHrefs, localeCode, renderChildSections]);

  return content;
};
